<script lang="ts">
	import { onDestroy } from "svelte";
	import type { Unsubscriber } from "svelte/store";
	import type { FilterStores } from "../../../types/types.serpPage";
	import { formObjectStores } from "../../stores/stores.searchform";
	import { Icon } from "../../../generic/components";
	import { CONFIG_SERP_PAGE as CONFIG } from "../../serpPage.config";
	import { msg } from "../../modules/utils.serpPage";

	const { USED_FILTERS } = CONFIG;

	let filtredUsed: FilterStores[] = [];

	const formObjectStoresUnsubscribe: Unsubscriber = formObjectStores.subscribe(form => {
		filtredUsed = form.filters.filter(filter => filter.currentValueSelected.length > 0);
	});

	function removeFilter(filter: FilterStores, selectedValue: string): void {
		formObjectStores.clearValueFilter(filter.symbol, selectedValue);
	}

	onDestroy(formObjectStoresUnsubscribe);
</script>

{#if filtredUsed.length > 0}
	<ul class="usedFilterWrapper">
		<li>
			<b>{msg("selectedFilters")}</b>
		</li>
		{#each filtredUsed as filter}
			{#if USED_FILTERS.COMPACT}
				<li class="usedFilter">
					{#if filter.typeProp != "boolean"}
						<span>{filter.name}: </span>
					{/if}
					{#each filter.getValueToUsedFiltersComponent() as selectedValue}
						<div class="usedFiltersValue">
							{#if filter.typeProp == "boolean"}
								<span>{filter.name}</span>
							{:else}
								<span>{filter.getNameOfValue(selectedValue)}</span>
							{/if}
							<button class="btnIcon" type="button" on:click={() => removeFilter(filter, selectedValue)} title="{msg('delete')} {selectedValue}">
								<Icon template="ic-cross" width="0.5rem" height="0.5rem" />
							</button>
						</div>
					{/each}
				</li>
			{:else}
				{#each filter.getValueToUsedFiltersComponent() as selectedValue}
					<li class="usedFilter">
						{#if filter.typeProp == "boolean"}
							<span>{filter.name}</span>
						{:else}
							<div>
								<span>{filter.name}: </span>
								<span>{selectedValue}</span>
							</div>
						{/if}
						<button class="btnIcon" type="button" on:click={() => removeFilter(filter, selectedValue)} title="{msg('delete')} {selectedValue}">
							<Icon template="ic-cross" width="0.5rem" height="0.5rem" />
						</button>
					</li>
				{/each}
			{/if}
		{/each}
		{#if USED_FILTERS.RESET_BUTTON_THRESHOLD != null && filtredUsed.length > USED_FILTERS.RESET_BUTTON_THRESHOLD}
			<li class="reset-filters">
				<button class="btnIcon" type="button" on:click={() => formObjectStores.clearAllFilters()} title={msg("deleteAll")}>
					<Icon template="ic-cross" width="0.5rem" height="0.5rem" />
				</button>
				<span>{msg("deleteAll")}</span>
			</li>
		{/if}
	</ul>
{/if}
